// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"gS","fixed":"hS","nonLayerdFacets":"iS","productCount":"jS","facetBack":"kS","arrow":"lS"};